module.exports = __webpack_public_path__ + "img/_.1407f642.svg";